import React from 'react';
import Hero3 from '../Components/Hero/Hero3';
import LocationInMap from '../Components/Map/LocationInMap';
import Contact from '../Components/Contact/Contact';
import Department from '../Components/Department/Department';
import Appointment from '../Components/Appointment/Appointment';
import About from '../Components/About/About';
import Iconbox from '../Components/Iconbox/Iconbox';
import PostWrapper from '../Components/Post/PostWrapper';
import SpecialistsSlider from '../Components/Slider/SpecialistsSlider';
import TestimonialSlider from '../Components/Slider/TestimonialSlider';
import BrandSlider from '../Components/Slider/BrandSlider';
import Newsletter from '../Components/Newsletter/Newsletter';
import Accordion from '../Components/Accordion/Accordion';
import PriceSlider from '../Components/Slider/PriceSlider';
import Funfact from '../Components/Funfact/Funfact';
import BeforeAfter from '../Components/BeforeAfter/BeforeAfter';
import MasonryGallery from '../Components/Gallery/Gallery';

const heroData = [
  {
    title: "Cuidamos tu salud<br />con calidez y calidad",
    subTitle: "Primer nivel de atención médica accesible y humana.",
    bgImg: '/images/hero-bg1.jpg',
  },
  {
    title: "Especialistas<br />a tu servicio",
    subTitle: "Tecnología y experiencia, comprometidos contigo.",
    bgImg: '/images/hero-bg15.jpg',
  }
];

const iconboxData = [
  {
    bg: 'purple',
    icon: 'icons/icon1.svg',
    title: 'Personal médico calificado',
    subTitle:
      'Contamos con un equipo humano con amplia experiencia clínica y calidad humana.',
  },
  {
    bg: 'green',
    icon: 'icons/icon5.svg',
    title: 'Atención de calidad',
    subTitle:
      'Servicios de salud con enfoque integral, humano y orientado a resultados efectivos.',
  },
  {
    bg: 'red',
    icon: 'icons/icon6.svg',
    title: 'Espacios cómodos y seguros',
    subTitle:
      'Instalaciones modernas y seguras, diseñadas para ofrecer confort y bienestar en cada visita médica.',
  },
];

const aboutData = {
  title:
    'Somos una IPS comprometida con atención primaria integral y servicios especializados',
  subTitle:
    'FISIOTER S.A.S. es una entidad privada dedicada a la prestación de servicios<br /> de salud en el primer nivel de atención. Ofrecemos servicios accesibles y oportunos,<br />con un equipo de profesionales con experiencia clínica, sentido humano y social.<br /><br />Trabajamos bajo un sistema de gestión de calidad con enfoque en el liderazgo,<br />la mejora continua y la participación activa de nuestro personal. Cada proceso<br />está orientado a garantizar atención segura, efectiva y centrada en el bienestar<br />integral de nuestros usuarios.',

  avater: {
    img: 'images/avatar7.png',
    name: 'Sugeila Oñate Rosado',
    designation: 'Fundadora y Directora',
  },
  timeTable: [
    {
      day: 'Lunes',
      startTime: '7:00 am',
      endTime: '5:00 pm',
    },
    {
      day: 'Martes',
      startTime: '7:00 am',
      endTime: '5:00 pm',
    },
    {
      day: 'Miércoles',
      startTime: '7:00 am',
      endTime: '5:00 pm',
    },
    {
      day: 'Jueves',
      startTime: '7:00 am',
      endTime: '5:00 pm',
    },
    {
      day: 'Viernes',
      startTime: '7:00 am',
      endTime: '5:00 pm',
    },
    {
      day: 'Sábado',
      startTime: '8:00 am',
      endTime: '12:00 pm',
    },
    {
      day: 'Domingo',
      startTime: 'No hay atención al público',
    },
],
contact: '(+57) 300 827 1686',
};

const specialistData = [
  {
    img: 'images/doc1.jpg',
    name: 'Dra. Marimar Torres Orozco',
    designation: 'Medico Pediatra',
    authorLink: '/doctor-profile'
  },
  {
    img: 'images/doc2.jpg',
    name: 'Dr. Marlon Consuegra',
    designation: 'Otorrinolaringólogo',
    authorLink: '/doctor-profile'
  },
  {
    img: 'images/doc3.jpg',
    name: 'Dr. Henrry De Gregorio Saltaren',
    designation: 'Dermatólogo',
    authorLink: '/doctor-profile'
  },
  {
    img: 'images/doc4.jpg',
    name: 'Dr. Erson Álvarez',
    designation: 'Urólogo',
    authorLink: '/doctor-profile'
  },
  {
    img: 'images/doc5.jpg',
    name: 'Dr. Franklin Figueroa',
    designation: 'Cardiólogo',
    authorLink: '/doctor-profile'
  },
  {
    img: 'images/doc6.jpg',
    name: 'Dr. Augusto Puertas',
    designation: 'Medicina Interna',
    authorLink: '/doctor-profile'
  },
  {
    img: 'images/doc7.jpg',
    name: 'Dr. Jhoniffer Farfán Zubiria',
    designation: 'Medico Pediatra',
    authorLink: '/doctor-profile'
  },
  {
    img: 'images/doc8.jpg',
    name: 'Dra. Karen Barros',
    designation: 'Ginecóloga',
    authorLink: '/doctor-profile'
  },
  {
    img: 'images/doc9.jpg',
    name: 'Dr. Hermes Oñate Rosado',
    designation: 'Cardiólogo - Internista',
    authorLink: '/doctor-profile'
  },
  {
    img: 'images/doc10.jpg',
    name: 'Dra. Yolainis Rosado',
    designation: 'Gastroenteróloga Pediatra',
    authorLink: '/doctor-profile'
  },
  {
    img: 'images/doc11.jpg',
    name: 'Dra. Vierys Zárate ',
    designation: 'Neuróloga',
    authorLink: '/doctor-profile'
  },
  {
    img: 'images/doc12.jpg',
    name: 'Dra. Delvis Murgas ',
    designation: 'Bacterióloga',
    authorLink: '/doctor-profile'
  },
  {
    img: 'images/doc13.jpg',
    name: 'Dra. Audris Araujo Ariño',
    designation: 'Citóloga',
    authorLink: '/doctor-profile'
  },
];

const beforeAfterData = {
  bgImg: '/images/before-after-bg.jpg',
  beforeImg: '/images/after.jpg',
  afterImg: 'images/before.jpg',
};

const priceData = [
  {
    title: 'Blood Test',
    price: '39',
    featureList: [
      {
        title: 'First Description',
        status: '1',
      },
      {
        title: 'Second Description',
        status: '1',
      },
      {
        title: 'Third Description',
        status: '1',
      },
      {
        title: 'Fourth Description',
        status: '0',
      },
      {
        title: 'Fifth Description',
        status: '0',
      },
    ],
  },
  {
    title: 'Hemoglobin Test',
    price: '89',
    featureList: [
      {
        title: 'First Description',
        status: '1',
      },
      {
        title: 'Second Description',
        status: '1',
      },
      {
        title: 'Third Description',
        status: '1',
      },
      {
        title: 'Fourth Description',
        status: '1',
      },
      {
        title: 'Fifth Description',
        status: '0',
      },
    ],
  },
  {
    title: 'Homocysteine Test',
    price: '150',
    featureList: [
      {
        title: 'First Description',
        status: '1',
      },
      {
        title: 'Second Description',
        status: '1',
      },
      {
        title: 'Third Description',
        status: '1',
      },
      {
        title: 'Fourth Description',
        status: '1',
      },
      {
        title: 'Fifth Description',
        status: '1',
      },
    ],
  },
  {
    title: 'Blood Test',
    price: '39',
    featureList: [
      {
        title: 'First Description',
        status: '1',
      },
      {
        title: 'Second Description',
        status: '1',
      },
      {
        title: 'Third Description',
        status: '1',
      },
      {
        title: 'Fourth Description',
        status: '0',
      },
      {
        title: 'Fifth Description',
        status: '0',
      },
    ],
  },
  {
    title: 'Hemoglobin Test',
    price: '89',
    featureList: [
      {
        title: 'First Description',
        status: '1',
      },
      {
        title: 'Second Description',
        status: '1',
      },
      {
        title: 'Third Description',
        status: '1',
      },
      {
        title: 'Fourth Description',
        status: '1',
      },
      {
        title: 'Fifth Description',
        status: '0',
      },
    ],
  },
  {
    title: 'Homocysteine Test',
    price: '150',
    featureList: [
      {
        title: 'First Description',
        status: '1',
      },
      {
        title: 'Second Description',
        status: '1',
      },
      {
        title: 'Third Description',
        status: '1',
      },
      {
        title: 'Fourth Description',
        status: '1',
      },
      {
        title: 'Fifth Description',
        status: '1',
      },
    ],
  },
];

const faqData = {
  title: 'Preguntas Frecuentes',
  img: 'images/faq-img.png',
  bgImg: 'shape/faq-bg.svg',
  faqItems: [
    {
      title: '¿Qué servicios ofrece Fisioters SAS?',
      content: `Ofrecemos consulta médica general, especialidades clínicas, diagnóstico por imágenes, terapias y rehabilitación integral, atención domiciliaria, odontología y seguridad y salud en el trabajo.`,
    },
    {
      title: '¿Cómo puedo agendar una cita médica?',
      content: `Puede agendar su cita llamandonos o escribiendonos al WhatsApp (+57) 300 827 1686, tambien puedes hacerlo utilizando nuestro formulario de citas en línea disponible en la sección de contacto.`,
    },
    {
      title: '¿Qué horarios de atención tienen?',
      content: `Atendemos de lunes a viernes de 7:00 am a 5:00 pm, sábados de 8:00 am a 12:00 pm y domingos no hay atención al público.`,
    },
    {
      title: '¿Ofrecen atención domiciliaria?',
      content: `Sí, contamos con un servicio de hospitalización en casa para pacientes que requieren atención médica y terapias en su domicilio.`,
    },
    {
      title: '¿Cómo puedo solicitar información sobre seguridad y salud en el trabajo?',
      content: `Puede comunicarse con nosotros a través del teléfono o correo electrónico y le brindaremos asesoría especializada en SGSST.`,
    },
  ],
};

const newsletterData = {
  bgImg: 'images/news-letter-bg.png',
  contact: '(+01) - 234 567 890',
};

const brandData = [
  {
    bg: 'orange',
    img: 'images/client1.png',
  },
  {
    bg: 'blue',
    img: 'images/client2.png',
  },
  {
    bg: 'red',
    img: 'images/client3.png',
  },
  {
    bg: 'green',
    img: 'images/client4.png',
  },
  {
    bg: 'dip-blue',
    img: 'images/client5.png',
  },
  {
    bg: 'orange',
    img: 'images/client1.png',
  },
  {
    bg: 'blue',
    img: 'images/client2.png',
  },
  {
    bg: 'red',
    img: 'images/client3.png',
  },
  {
    bg: 'green',
    img: 'images/client4.png',
  },
  {
    bg: 'dip-blue',
    img: 'images/client5.png',
  },
];

const mapLocationURL =
  'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3921.601029244573!2d-72.98059062598496!3d10.61033376223751!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e8aefba270c173b%3A0x4e63a0b5a0e1e5ae!2sFISIOTER%20S.A.S!5e0!3m2!1ses-419!2sco!4v1747716733857!5m2!1ses-419!2sco';

const Home3 = () => {
  return (
    <>
      <div className='st-height-b125 st-height-lg-b80' id='home'></div>
      <Hero3 data={heroData} />
      <Iconbox data={iconboxData} />
      <About data={aboutData} />
      <Department />
      <Appointment />
      <SpecialistsSlider data={specialistData} />
      <hr />
      <Accordion data={faqData} />
      <Contact />
      <LocationInMap data={mapLocationURL} />
    </>
  );
};

export default Home3;
